import { render, staticRenderFns } from "./RequiredKit.vue?vue&type=template&id=bb1c65fa&scoped=true"
import script from "./RequiredKit.vue?vue&type=script&lang=ts"
export * from "./RequiredKit.vue?vue&type=script&lang=ts"
import style0 from "./RequiredKit.vue?vue&type=style&index=0&id=bb1c65fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1c65fa",
  null
  
)

export default component.exports